import { render, staticRenderFns } from "./defect_summary.vue?vue&type=template&id=be4b475e&scoped=true"
import script from "./defect_summary.vue?vue&type=script&lang=js"
export * from "./defect_summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4b475e",
  null
  
)

export default component.exports